import { FC, useState, useEffect } from 'react';
import { TabDesign, TabLayout, Theme } from '../types/enums';
import Tabs from '../Tabs/Tabs';
import { TabsPropsExtend, TabDataExtend } from './types/propTypes';
import { TabType } from './types/enum';
import AdminTab from './AdminTab';
import styles from './TabsComponent.module.scss';

export const TabsComponent: FC<TabsPropsExtend> = (props: TabsPropsExtend) => {
  const {
    theme = Theme.PURPLE,
    design = TabDesign.ICON_CIRCLE,
    tabList,
    selectorType,
    onTabClick,
    sortAndFilter,
    sortAndFilterCount,
    selectedTab = 0,
    tabType = TabType.COMPONENT,
  } = props;
  const [currentTab, setCurrentTab] = useState(0);

  function handleClick(index: number) {
    if (onTabClick) {
      onTabClick(tabList[index].id, index);
    }
  }
  useEffect(() => {
    if (typeof selectedTab === 'number') {
      setCurrentTab(selectedTab);
    } else {
      const foundTab = tabList.findIndex((tab) => selectedTab === tab.id);
      if (foundTab !== -1) {
        setCurrentTab(foundTab);
      }
    }
  }, [selectedTab]);

  return (
    <div className={styles['body']}>
      {tabType === TabType.COMPONENT && (
        <Tabs
          className={`${styles['tabs']} ${styles[design === TabDesign.ICON_CIRCLE ? design : '']}`}
          layout={TabLayout.HORIZONTAL}
          tabList={tabList as TabDataExtend[]}
          theme={theme}
          design={design}
          selectedTab={currentTab}
          selectorType={selectorType}
          sortAndFilter={sortAndFilter}
          sortAndFilterCount={sortAndFilterCount}
          onTabClick={(index) => handleClick(index)}
        />
      )}
      {tabType === TabType.ADMIN && <AdminTab selectedTab={selectedTab} tabList={tabList} onTabClick={onTabClick} />}
    </div>
  );
};

export default TabsComponent;
export { TabType };
export type { TabsPropsExtend };
